
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/extensions/datadog",
      function () {
        return require("private-next-pages/extensions/datadog.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/extensions/datadog"])
      });
    }
  